import React, { Component, Fragment } from 'react';
import { PageWrapper, ErrorRedirect, PageLoader } from './../components/';
import PortfolioHeader from './../components/photo-film-project/PortfolioHeader';
import FlexiblePortfolioLayout from './../components/photo-film-project/FlexiblePortfolioLayout';
import SocialShare from './../components/SocialShare';
import RelatedPosts from './../components/RelatedPosts';

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wpData: {},
      loading: true,
      error: false
    };
    this.slug = `${process.env.API_URL}portfolio/?name=`;
  }

  componentDidMount() {
    this._apiRequest(`${this.slug}${this.props.match.params.pageSlug}`);
  }
  
  componentWillReceiveProps(nextProps) {
    this._apiRequest(`${this.slug}${nextProps.match.params.pageSlug}`);
  }

  _apiRequest(url) {
    fetch(url).then((response) => {
      if (!response.ok) { throw Error(response.statusText); }
      return response.json();
    }).then((res) => {
      this.setState({
        wpData: res.data,
        loading: false,
        error: false
      });
    }).catch(() => {
      this.setState({
        error: true,
        loading: false,
        wpData: false
      });
    });
  }

  render() {
    return (
      <Fragment>
        {(this.state.loading) ? <PageLoader/> : (this.state.error) ? <ErrorRedirect/>
          : <PortfolioContent data={this.state.wpData}/>
        }
      </Fragment>
    );
  };
};

const PortfolioContent = (props) => {
  return (
    <PageWrapper pageId={'photo-film-project'}>
      <PortfolioHeader HeaderData={{
        headline: props.data.headline,
        description: props.data.description
      }}/>
      <FlexiblePortfolioLayout LayoutItems={props.data.portfolio_layout} />
      <SocialShare Meta={props.data.page_meta} />
      <RelatedPosts Posts={props.data.related_posts.posts}/>
    </PageWrapper>
  );
};



// WEBPACK FOOTER //
// ./src/pages/SinglePortfolio.js